export const validateHexString = str => {
  if (!str) {
    return false
  }

  if (typeof str === 'object' && !(str instanceof Array)) {
    if ('_bsontype' in str) {
      return true
    }
    return false
  }

  if (typeof str === 'string') {
    if (str?.length !== 24) return false
    for (let i = 0; i < 24; i++) {
      const char = str.charCodeAt(i)
      if (
        // Check for ASCII 0-9
        (char >= 48 && char <= 57) ||
        // Check for ASCII a-f
        (char >= 97 && char <= 102) ||
        // Check for ASCII A-F
        (char >= 65 && char <= 70)
      ) {
        // eslint-disable-next-line no-continue
        continue
      }
      return false
    }
  } else {
    return false
  }

  return true
}
